import { z } from 'zod'
import { type ServerAppSetting } from '../../models/AppSetting'

export const ServerAppSettingDTO = z.object({
  ip: z.string().nullish(),
  use_http: z.boolean().nullish()
})

export type ServerAppSettingDTO = z.infer<typeof ServerAppSettingDTO>

export function mapServerAppSettingToDTO (model: ServerAppSetting): ServerAppSettingDTO {
  return {
    ip: model.ip,
    use_http: model.useHttp
  }
}

export function mapDTOToServerAppSetting (dto: ServerAppSettingDTO): ServerAppSetting {
  return {
    ip: dto.ip ?? undefined,
    useHttp: dto.use_http ?? undefined
  }
}
